export function phaseFilterByName({ name }, search) {
  return name.toLowerCase().includes(search.toLowerCase())
}

export function getDataItems(response) {
  return response.data
}
